import { useCallback } from 'react';
import { NavigateOptions, useLocation } from 'react-router';
import { useNavigateAsync } from './UseNavigateAsyncHook';

export function useNavigateWithStateAsync(): (
  state: unknown,
  options?: Omit<NavigateOptions, 'state'>
) => Promise<void> {
  const navigate = useNavigateAsync();
  const location = useLocation();

  return useCallback(
    (state: unknown, options: Omit<NavigateOptions, 'state'> = {}): Promise<void> => {
      return navigate(
        { pathname: location.pathname, search: location.search, hash: location.hash },
        { ...options, state }
      );
    },
    [navigate, location]
  );
}
